module.exports = __webpack_public_path__ + "static/media/img_bg.c32198d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/AntD/assets/img/img_bg.png
// module id = 5262
// module chunks = 0